import api from './api';

export const groupService = {
  previewSchedule: (data) => api.post('/groups/preview-schedule/', data),
  createGroup: (data) => api.post('/groups/groups/', data),
  getMyGroups: (params) => api.get('/groups/groups/', { params }),
  getGroup: (id) => api.get(`/groups/groups/${id}/`),
  joinByCode: (data) => api.post('/groups/groups/join/', data),
  inviteMember: (id, data) => api.post(`/groups/groups/${id}/invite/`, data),
  acceptInvite: (token) => api.post(`/groups/invites/${token}/accept/`),
  declineInvite: (token) => api.post(`/groups/invites/${token}/decline/`),
  startRotation: (id) => api.post(`/groups/groups/${id}/start/`),
  getCycles: (id) => api.get(`/groups/groups/${id}/cycles/`),
  contribute: (id, cycleId, data) => api.post(`/groups/groups/${id}/cycles/${cycleId}/contribute/`, data),
  getContributionHistory: (id) => api.get(`/groups/groups/${id}/contributions/`),
  leaveGroup: (id) => api.post(`/groups/groups/${id}/leave/`),
  reportDispute: (id, data) => api.post(`/groups/groups/${id}/report-issue/`, data),
};

export const adminGroupService = {
  getGroups: (params) => api.get('/groups/admin/groups/', { params }),
  getGroup: (id) => api.get(`/groups/admin/groups/${id}/`),
  getPendingPayouts: (params) => api.get('/groups/admin/queue/pending-payouts/', { params }),
  getShortCycles: (params) => api.get('/groups/admin/queue/short-cycles/', { params }),
  executePayout: (id) => api.post(`/groups/admin/payouts/${id}/execute/`),
  resolveShortfall: (cycleId) => api.post(`/groups/admin/cycles/${cycleId}/resolve-shortfall/`),
};
